import type { TabProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

const Tabs = (theme: Theme) => {
  return {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TabProps }) => ({
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(5),
            },
          },
          '&:not(.Mui-selected)': {
            color: theme.palette.text.secondary,
          },
          fontWeight: theme.typography.fontWeightMedium,
          minWidth: 48,
          opacity: 1,
          padding: 0,
          ...((ownerState.iconPosition === 'start' ||
            ownerState.iconPosition === 'end') && {
            minHeight: 48,
          }),
        }),
      },
    },
    MuiTabs: {
      defaultProps: {
        allowScrollButtonsMobile: true,
        textColor: 'inherit',
        variant: 'scrollable',
      },
      styleOverrides: {
        scrollButtons: {
          borderRadius: '50%',
          width: 48,
        },
      },
    },
  };
};

export default Tabs;
